export const API_URI = 'https://ztm-face-recognition-node.herokuapp.com';
